/**
 * @flow
 * @relayHash effd46c23933e5f0dac461a4f518217e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CrawlErrorsTable_project$ref = any;
export type httpStatus_HttpStatusCategory_CrawlErrorsTable_QueryVariables = {|
  host: string
|};
export type httpStatus_HttpStatusCategory_CrawlErrorsTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: CrawlErrorsTable_project$ref
  |}
|};
export type httpStatus_HttpStatusCategory_CrawlErrorsTable_Query = {|
  variables: httpStatus_HttpStatusCategory_CrawlErrorsTable_QueryVariables,
  response: httpStatus_HttpStatusCategory_CrawlErrorsTable_QueryResponse,
|};
*/


/*
query httpStatus_HttpStatusCategory_CrawlErrorsTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...CrawlErrorsTable_project
    id
  }
}

fragment CrawlErrorsTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        crawlErrors(offset: 0, limit: 20, url: {operator: AND, values: []}, errors: [], sourceUrl: {operator: AND, values: []}) {
          count
          edges {
            node {
              ...CrawlErrorsRow_issue
              id
            }
          }
        }
        countCodesCrawlErrors(url: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {
          error
          count
        }
        id
      }
    }
  }
}

fragment CrawlErrorsRow_issue on CrawlError {
  id
  type
  source_url
  severity
  error
  url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v4 = {
  "kind": "Literal",
  "name": "sourceUrl",
  "value": v3,
  "type": "TextFilters"
},
v5 = {
  "kind": "Literal",
  "name": "url",
  "value": v3,
  "type": "TextFilters"
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "error",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "httpStatus_HttpStatusCategory_CrawlErrorsTable_Query",
  "id": null,
  "text": "query httpStatus_HttpStatusCategory_CrawlErrorsTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...CrawlErrorsTable_project\n    id\n  }\n}\n\nfragment CrawlErrorsTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        crawlErrors(offset: 0, limit: 20, url: {operator: AND, values: []}, errors: [], sourceUrl: {operator: AND, values: []}) {\n          count\n          edges {\n            node {\n              ...CrawlErrorsRow_issue\n              id\n            }\n          }\n        }\n        countCodesCrawlErrors(url: {operator: AND, values: []}, sourceUrl: {operator: AND, values: []}) {\n          error\n          count\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment CrawlErrorsRow_issue on CrawlError {\n  id\n  type\n  source_url\n  severity\n  error\n  url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "httpStatus_HttpStatusCategory_CrawlErrorsTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CrawlErrorsTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "httpStatus_HttpStatusCategory_CrawlErrorsTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "crawlErrors",
                        "storageKey": "crawlErrors(errors:[],limit:20,offset:0,sourceUrl:{\"operator\":\"AND\",\"values\":[]},url:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "errors",
                            "value": [],
                            "type": "[String]"
                          },
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          v2,
                          v4,
                          v5
                        ],
                        "concreteType": "CrawlErrorsConnection",
                        "plural": false,
                        "selections": [
                          v6,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CrawlErrorsEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "CrawlError",
                                "plural": false,
                                "selections": [
                                  v7,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "type",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "severity",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v8,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countCodesCrawlErrors",
                        "storageKey": "countCodesCrawlErrors(sourceUrl:{\"operator\":\"AND\",\"values\":[]},url:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          v4,
                          v5
                        ],
                        "concreteType": "CountError",
                        "plural": true,
                        "selections": [
                          v8,
                          v6
                        ]
                      },
                      v7
                    ]
                  }
                ]
              }
            ]
          },
          v7
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7d70e26e60ab37e2d296cd58a6639c17';
module.exports = node;
